import classNames from 'classnames';
import c from './application-details.module.scss';
import { fontStyles } from '@monash/portal-react';
import UnitsField from './units-field/UnitsField';
import StartDateField from './start-date-field/StartDateField';
import DiscoveryMethodFields from './discovery-methods-field/DiscoveryMethodsField';
import AdditionalInfoField from './additional-info-field/AdditionalInfoField';

const ApplicationDetails = () => {
  // NOTE: Currently hard-coded to Peer Assisted Study Sessions (PASS)

  return (
    <div className={c.applicationDetails}>
      <div className={classNames(fontStyles.heading, fontStyles.sm)}>
        Application Details
      </div>
      <div className={c.fieldsContainer}>
        <UnitsField />
        <StartDateField />
        <DiscoveryMethodFields />
        <AdditionalInfoField />
      </div>
    </div>
  );
};

export default ApplicationDetails;
